// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pingflo-manual {
  position: fixed;
  inset: 0;
  z-index: 12080;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.pingflo-manual__backdrop {
  position: absolute;
  inset: 0;
  border: 0;
  background: rgba(2, 6, 23, 0.4);
}

.pingflo-manual__sheet {
  position: relative;
  width: min(560px, 100%);
  max-height: min(78vh, 680px);
  overflow: auto;
  margin: 0 10px max(10px, env(safe-area-inset-bottom));
  padding: 14px 14px 18px;
  border-radius: 18px;
  background: #0f172a;
  color: #f8fafc;
}

.pingflo-manual__head,
.pingflo-manual__tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.pingflo-manual__head h2 {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 1.05rem;
}

.pingflo-manual__head button,
.pingflo-manual__list button {
  border: 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  cursor: pointer;
}

.pingflo-manual__head button {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
}

.pingflo-manual__tabs {
  justify-content: flex-start;
  margin: 12px 0;
}

.pingflo-manual__tabs button {
  border: 0;
  border-radius: 999px;
  padding: 6px 12px;
  background: transparent;
  color: rgba(248, 250, 252, 0.7);
  font-weight: 700;
  cursor: pointer;
}

.pingflo-manual__tabs button.is-on {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.pingflo-manual__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pingflo-manual__list li {
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
}

.pingflo-manual__list strong {
  display: block;
  margin-bottom: 4px;
}

.pingflo-manual__list p {
  margin: 0 0 8px;
  color: rgba(248, 250, 252, 0.78);
  font-size: 0.88rem;
  line-height: 1.4;
}

.pingflo-manual__list button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  font-size: 0.78rem;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/tour/PingfloManual.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;EACd,qDAAqD;EACrD,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".pingflo-manual {\n  position: fixed;\n  inset: 0;\n  z-index: 12080;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.pingflo-manual__backdrop {\n  position: absolute;\n  inset: 0;\n  border: 0;\n  background: rgba(2, 6, 23, 0.4);\n}\n\n.pingflo-manual__sheet {\n  position: relative;\n  width: min(560px, 100%);\n  max-height: min(78vh, 680px);\n  overflow: auto;\n  margin: 0 10px max(10px, env(safe-area-inset-bottom));\n  padding: 14px 14px 18px;\n  border-radius: 18px;\n  background: #0f172a;\n  color: #f8fafc;\n}\n\n.pingflo-manual__head,\n.pingflo-manual__tabs {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.pingflo-manual__head h2 {\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 1.05rem;\n}\n\n.pingflo-manual__head button,\n.pingflo-manual__list button {\n  border: 0;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n  cursor: pointer;\n}\n\n.pingflo-manual__head button {\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n}\n\n.pingflo-manual__tabs {\n  justify-content: flex-start;\n  margin: 12px 0;\n}\n\n.pingflo-manual__tabs button {\n  border: 0;\n  border-radius: 999px;\n  padding: 6px 12px;\n  background: transparent;\n  color: rgba(248, 250, 252, 0.7);\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.pingflo-manual__tabs button.is-on {\n  background: rgba(255, 255, 255, 0.12);\n  color: #fff;\n}\n\n.pingflo-manual__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.pingflo-manual__list li {\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.pingflo-manual__list strong {\n  display: block;\n  margin-bottom: 4px;\n}\n\n.pingflo-manual__list p {\n  margin: 0 0 8px;\n  color: rgba(248, 250, 252, 0.78);\n  font-size: 0.88rem;\n  line-height: 1.4;\n}\n\n.pingflo-manual__list button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
